import * as XLSX from "xlsx";

const REQUIRED = ["Designation", "Code", "Employee Name", "Mobile Number", "D.O.J/L", "Working Days", "Total"];

function periodFromSheetName(name) {
  const match = String(name || "").match(/(Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)[- _]+(20\d{2}|\d{2})/i);
  if (!match) return "";
  return `${match[1].slice(0, 3)}-${match[2].slice(-2)}`;
}

function money(value, code) {
  const amount = Number(String(value ?? "").replace(/,/g, ""));
  if (!Number.isFinite(amount) || amount < 0) throw new Error(`${code}: Total must be a valid non-negative amount.`);
  return amount;
}

export function parseCortevaCrcWorkbook(buffer) {
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheetName = workbook.SheetNames.find((name) => /crc/i.test(name)) || workbook.SheetNames[0];
  if (!sheetName) throw new Error("The CRC workbook has no worksheet.");
  const matrix = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1, defval: "", raw: false });
  const headerIndex = matrix.findIndex((row) => REQUIRED.every((required) => row.some((cell) => String(cell).trim().toLowerCase() === required.toLowerCase())));
  if (headerIndex < 0) throw new Error(`CRC sheet ${sheetName} is missing the required employee headers.`);
  const headers = matrix[headerIndex].map((cell) => String(cell).trim());
  const records = matrix.slice(headerIndex + 1).map((row) => Object.fromEntries(headers.map((header, index) => [header, row[index]])));
  const codes = new Set();
  const rows = records.filter((row) => /^C\d+$/i.test(String(row.Code || "").trim())).map((row) => {
    const code = String(row.Code).trim().toUpperCase();
    if (codes.has(code)) throw new Error(`Duplicate CRC employee code ${code}.`);
    codes.add(code);
    if (!String(row["Employee Name"] || "").trim()) throw new Error(`${code}: Employee Name is required.`);
    const salary = money(row.Total, code);
    return {
      code,
      name: String(row["Employee Name"]).trim(),
      designation: String(row.Designation || "").trim(),
      contact: String(row["Mobile Number"] || "").trim(),
      joined: String(row["D.O.J/L"] || "").trim(),
      days: Number(row["Working Days"] || 0),
      salary,
      gli: 140,
      pessi: 2664,
      eobi: 2000,
      serviceFee: 1250
    };
  });
  if (!rows.length) throw new Error("No valid CRC employee codes were found.");
  const salaryTotal = Math.round(rows.reduce((sum, row) => sum + row.salary, 0) * 100) / 100;
  const reimbursement = Math.round(rows.reduce((sum, row) => sum + row.salary + row.gli + row.pessi + row.eobi, 0) * 100) / 100;
  const serviceCharges = rows.length * 1250;
  const gst = Math.round(serviceCharges * 0.16);
  return { rows, sheetName, period: periodFromSheetName(sheetName), headCount: rows.length, salaryTotal, reimbursement, serviceCharges, gst, total: reimbursement + serviceCharges + gst };
}
